import React from "react";
import { AboutComponents } from "./Allcomponents";
export default function About() {
  return (
    <>
      <AboutComponents
        main_heading="Web_Developers"
        main_paragraph="Hello! Welcome to our dealing center here you can place order of
        your home with beatiful spectutaram and and complete your dreams
        different places like KDA, main etc you can check out with our
        areas page and completer your desire dreams."
        img_src="https://mdbootstrap.com/img/illustrations/graphics(4).png"
        btn_txt="Contact"
      />
    </>
  );
}
